import React, { Fragment } from 'react';
import classNames from 'classnames';
import styles from './Button.scss';
import { Link } from 'react-router-dom';
import Spinner from '../Spinner/Spinner';
import SpinnerStyles from '../Spinner/Spinner.scss';

const button = props => {
	return (
		<button
			type={props.type}
			data-test-id={props.testId || props['data-test-id']}
			className={classNames(
				styles.Default,
				{ [styles.transparent]: props.transparent },
				props.className,
				props.active ? styles.Active : ''
			)}
			disabled={props.disabled}
			onClick={props.onClick}
			ref={props.buttonRef}
		>
			{props.children}
		</button>
	);
};

const Button = props => {
	return (
		<Fragment>
			{props.isLoading ? (
				<div className={props.spinnerStyles[0]}>
					<div className={props.spinnerStyles[1]}>
						<Spinner
							className={classNames(
								props.spinnerStyles[2] || SpinnerStyles.EXMediumSpinner,
								SpinnerStyles.WhiteColor
							)}
							IEStyle={
								props.spinnerStyles[3] || SpinnerStyles.EXMediumSpinnerIE
							}
						/>
					</div>
				</div>
			) : (
				<div>
					{props.linkTo ? (
						<Link
							data-test-id={props.testId || props['data-test-id']}
							to={{ pathname: props.linkTo, state: { data: props.state } }}
						>
							{button(props)}
						</Link>
					) : (
						button(props)
					)}
				</div>
			)}
		</Fragment>
	);
};

export default Button;
